import { render, staticRenderFns } from "./oneStep.vue?vue&type=template&id=32960acc&scoped=true"
import script from "./oneStep.vue?vue&type=script&lang=js"
export * from "./oneStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32960acc",
  null
  
)

export default component.exports